@let items = itemsAndCreations.asSignal();
@let isLoading =
  archiveEc.plugins.currentListPlugin.feature.selectors.isLoading.asSignal();
@let selectedId =
  archiveEc.plugins.currentEntityPlugin.feature.selectors.getId().asSignal();

<div class="atn-summit-archive-catalog">
  @if (isLoading) {
    <atn-ds-loader type="typing" />
  } @else {
    @for (item of items; track $index) {
      @let edited =
        archiveEc.plugins.editingPlugin.feature.selectors
          .hasEditedEntity(item.id)
          .asSignal();
      @let isSubmitting =
        archiveEc.plugins.editingPlugin.feature.selectors.isSubmitting.asSignal();
      <div
        class="atn-summit-archive-catalog__item"
        [class.atn-summit-archive-catalog__item--selected]="
          item.id === selectedId
        "
        [class.atn-summit-archive-catalog__item--edited]="edited"
        [class.atn-summit-archive-catalog__item--cant-navigate]="
          isSubmitting && edited
        "
        (click)="!isSubmitting && onSelectItemHandler(item)"
      >
        <div class="atn-summit-archive-catalog__item-content">
          <h3
            class="atn-summit-archive-catalog__item-title"
            [class.atn-summit-archive-catalog__item-title--edited]="edited"
          >
            {{ item.name }}
          </h3>
          <span class="atn-summit-archive-catalog__item-date">{{
            item.date | date: 'MMM d, y - HH:mm'
          }}</span>
          <p class="atn-summit-archive-catalog__item-summary">
            {{ item.description | atnDsStripHtml }}
          </p>
        </div>
        @if (isSubmitting && edited) {
          <div class="atn-summit-archive-catalog__item-saving-overlay">
            <atn-ds-loader type="typing" />
          </div>
        }
        <button
          class="atn-summit-archive-catalog__item-delete"
          type="button"
          aria-label="Delete item"
          (click)="$event.stopPropagation(); onDeleteItemHandler(item)"
        >
          <i class="atn-icon atn-trash atn-red"></i>
        </button>
      </div>
    } @empty {
      <atn-ds-empty-state
        action="Add note"
        description="You have no notes yet. Click the button below to add your first note."
        layout="v"
        title="No Notes? Add One."
        type="add-row"
      />
    }
  }
</div>
